import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_URL = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use((config) => {
  // Dispensary JWT wins (for shop owner dashboards). If absent, fall back to
  // the consumer session token so Google-signed-in admins can hit /admin/*.
  const token =
    localStorage.getItem("bud_token") ||
    localStorage.getItem("bud_consumer_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

export const formatApiError = (err) => {
  const detail = err?.response?.data?.detail;
  if (!detail) return err.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((d) => d.msg || JSON.stringify(d)).join(", ");
  return String(detail);
};
